import {
    HttpResponse,
    PartyModel,
    QueryModel,
    RequestParams,
    PartyModelIEnumerableApiResultSuccess,
    PartyModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class PartiesDataService implements CrudService<PartyModel, PartyModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<PartyModel>): Promise<CrudListResponse<PartyModel>> {
        return ApiService.api.getPartyBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<PartyModel>> {
        return ApiService.api.getPartyById(id, params);
    }

    create(item: PartyModel, params?: RequestParams): Promise<CrudResponse<PartyModel>> {
        return ApiService.api.insertParty(item, params);
    }

    update(item: PartyModel, params?: RequestParams): Promise<PartyModel> {
        return ApiService.api.updateParty(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<PartyModel> {
        return ApiService.api.patchParty(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<PartyModel>): Promise<CrudListResponse<PartyModel>> {
        return ApiService.api.deleteParties(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<PartyModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportPartyBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

}
